module.exports = __webpack_public_path__ + "static/media/veryvell-group.ae38d251.png";